<script setup lang="ts">
import { inject } from "vue";

import type { Action } from "@/action/types";
import { stickyNoteActionMenuItemClicked } from "@/analytics/events/sticky";
import { trackEvent } from "@/analytics/track";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { action as actionAttrs } from "@/components/action/action";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import MenuListItem from "@/components/ui/MenuList/MenuListItem.vue";
import type { FeatureHighlightId } from "@/model/featureHighlight";
import { injectStrict } from "@/utils/vue";

import { moreMenuKey } from "./injectKeys";

const props = defineProps<{ action: Action<never[]>; highlight?: FeatureHighlightId }>();

const card = injectStrict(cardKey);
const more = inject(moreMenuKey, undefined);
const attrs = actionAttrs(props.action);

function activate() {
  attrs.onClick!();
  const actionId = props.action.data.id.replaceAll(".", "_");
  trackEvent(stickyNoteActionMenuItemClicked(actionId, card.type.functionality, true));
  more!.close();
}
</script>

<template>
  <MenuListItem
    v-if="more"
    :text="attrs.text"
    :icon="attrs.icon"
    :highlight
    @click="activate"
    @pointerenter="more.hover($event, null)"
  />
  <IconButton v-else v-bind="attrs" :highlight />
</template>
